module.exports = __webpack_public_path__ + "static/scene-3.42f6c4fa.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-3.png
// module id = 302
// module chunks = 2